// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"d784ffab","278":"1e6a9da4","533":"a27c7f3d","638":"1fecb0ee","901":"5a9bc1ed"}[chunkId] + ".chunk.js";
};